<template>
    <div class="mb-1">
        <b-container>
            <b-row>
                <b-col>
                    <div v-if="!isReading">
                        <b-alert varian="info" show><h5>Escanee el documento de la persona que va a ingresar</h5></b-alert>
                    </div>
                    <div v-if="isReading">
                        <i class="fa fa-barcode" aria-hidden="true"></i> Procesando...
                    </div>
                </b-col>
            </b-row>
        </b-container>
        <div class="read-fields">
            <b-form-input
                ref="scannerDocument"
                v-model.trim="scanner.document"
            ></b-form-input>
            <b-form-input
                v-model.trim="scanner.firstSurname"
                @focus.native="startReading"
            ></b-form-input>
            <b-form-input
                v-model.trim="scanner.lastSurname"
            ></b-form-input>
            <b-form-input
                v-model.trim="scanner.firstName"
            ></b-form-input>
            <b-form-input
                v-model.trim="scanner.lastName"
            ></b-form-input>
            <b-form-input
                v-model.trim="scanner.gender"
            ></b-form-input>
            <b-form-input
                v-model.trim="scanner.birthDate"
            ></b-form-input>
            <b-form-input
                v-model.trim="scanner.bloodType"
            ></b-form-input>
            <b-form-input
                v-model.trim="scanner.code1"
            ></b-form-input>
            <b-form-input
                v-model.trim="scanner.code2"
            ></b-form-input>
            <b-form-input
                @focus.native="onReaded"
            ></b-form-input>
        </div>
    </div>
</template>
<script>
export default {
    name: 'barcode_scanner',
    data: () => ({
        scanner: {
            document: '',
            firstSurname: '',
            lastSurname: '',
            firstNamr: '',
            lastName: '',
            gender: '',
            birthDate: '',
            bloodType: '',
            code1: '',
            code2: '',
        },
        isReading: false,
        fields: [],
        keyIndex: 0
    }),
    computed: {
        person() {
            const btext = this.scanner.birthDate;
            const birthDate = `${btext.substr(0, 4)}-${btext.substr(4, 2)}-${btext.substr(6)}`;
            const rh = this.scanner.bloodType.substr(0, 1);
            const bdictionary = {
                '/': '-',
                ']': '+'
            };
            const btype = bdictionary[this.scanner.bloodType.substr(1, 1)];
            const bloodType = `${rh}${btype}`;

            const regExp = /[^a-zA-Z ]/g;
            
            const cFirstName = this.scanner.firstName.replace(regExp, '').trim();
            const cLastName = this.scanner.lastName.replace(regExp, '').trim();
            const cFirstSurname = this.scanner.firstSurname.replace(regExp, '').trim();
            const cLastSurname = this.scanner.lastSurname.replace(regExp, '').trim();
            const fullName = `${cFirstName} ${cLastName} ${cFirstSurname} ${cLastSurname}`.trim().split(' ').filter(val => !!val).join(' ');
            return {
                document: parseInt(this.scanner.document.trim()).toString(),
                name: fullName,
                birthDate,
                bloodType,
                gender: this.scanner.gender
            }
        }
    },
    methods: {
        setReady(val) {
            if(this.writing) return;
            this.ready = val;
        },
        setWrinting(val) {
            this.writing = val;
        },
        onReaded() {
            //this.isReading = true;
            const readedPerson = JSON.parse(JSON.stringify(this.person));
            Object.keys(this.scanner).forEach(key => this.scanner[key] = '');
            this.$emit('input', readedPerson);
            this.$emit('onRead', readedPerson);
        },
        setFocus(e) {
            const {scannerDocument} = this.$refs;
            
            if(!scannerDocument) return;

            scannerDocument.focus();
        },
        setEvents() {
            window.addEventListener('keydown', (e) => this.validateKey(e));
        },
        removeEvents() {
            window.removeEventListener('keydown', this.validateKey);
        },
        validateKey(e) {
            if(e.keyCode < 48 || e.keyCode > 57) return;

            if(this.scanner.document.length === 0){
                this.setFocus();
                // this.isReading = true;
            };
            if(e.keyCode === 13) { // Enter
                this.isReading = false;
            }
            return false;
            
            // if(e.keyCode === 32 || (e.keyCode >= 48 && e.keyCode <= 90)) {
            //     this.isReading = true;
            //     if(!this.fields[this.keyIndex]) {
            //         this.fields[this.keyIndex] = '';
            //     }

            //     this.fields[this.keyIndex] += String.fromCharCode(e.keyCode);

            //     // this.setFocus();
            //     // this.isReading = true;
            // } else if(e.keyCode === 13) {
            //     this.isReading = false;
            // } else if(e.keyCode === 9) {
            //     this.keyIndex++;
            // } else if(e.keyCode === 191) {
            //     this.fields[this.keyIndex] += '-';
            // } else if (e.keyCode === 221) {
            //     this.fields[this.keyIndex] += '+';
            // }
            // switch(e.keyCode) {
            //     case 12:
            //     case 48:
            //         this.setFocus();
            //         this.isReading = true;
            //         return;
            //     case 13:
            //         this.isReading = false;
            //         return false;
            //     default:
            //         return true;
            // }
            return false;
        },
        startReading() {
            this.isReading = true;
        },
        stopReading() {
            this.isReading = false;
        }
    },
    mounted() {
        this.setFocus();
        this.setEvents();
        // this.$barcodeScanner.init(this.setFocus);
    },
    beforeDestroy(){
        this.removeEvents();
    }
}
</script>
<style scoped>
.read-fields {
    position: absolute;
    margin-top: -1000000px;
}
.reading {
  /* Start the shake animation and make the animation last for 0.5 seconds */
    animation: shake 0.3s; 

  /* When the animation is finished, start again */
    animation-iteration-count: infinite; 
}

@keyframes shake {
    0% { transform: translate(1px, 1px) rotate(0deg); }
    10% { transform: translate(-1px, -2px) rotate(-1deg); }
    20% { transform: translate(-3px, 0px) rotate(1deg); }
    30% { transform: translate(3px, 2px) rotate(0deg); }
    40% { transform: translate(1px, -1px) rotate(1deg); }
    50% { transform: translate(-1px, 2px) rotate(-1deg); }
    60% { transform: translate(-3px, 1px) rotate(0deg); }
    70% { transform: translate(3px, 1px) rotate(-1deg); }
    80% { transform: translate(-1px, -1px) rotate(1deg); }
    90% { transform: translate(1px, 2px) rotate(0deg); }
    100% { transform: translate(1px, -2px) rotate(-1deg); }
}
</style>